export default __webpack_public_path__ + "static/media/img-16.27f32dd2.png";